// CodeMirror 6 wrapper for markdown body editing.
// Theme: one-dark always (app has no light mode).
// Config: soft-wrap, line numbers off (prose), JetBrains Mono 13px.
//
// The heavy CodeMirror implementation is split into MarkdownBodyEditorInner
// and loaded lazily so it doesn't land in the main bundle.

import { lazy, Suspense } from "react";

const MarkdownBodyEditorInner = lazy(() => import("./MarkdownBodyEditorInner"));

export interface MarkdownBodyEditorProps {
  value: string;
  onChange: (next: string) => void;
  readOnly?: boolean;
}

function EditorFallback() {
  return (
    <div className="border border-border rounded-md overflow-hidden bg-card min-h-[400px] flex items-center justify-center">
      <div className="w-full h-full animate-pulse bg-muted/30 min-h-[400px]" />
    </div>
  );
}

export function MarkdownBodyEditor({ value, onChange, readOnly }: MarkdownBodyEditorProps) {
  return (
    <Suspense fallback={<EditorFallback />}>
      <MarkdownBodyEditorInner value={value} onChange={onChange} readOnly={readOnly} />
    </Suspense>
  );
}
